export default __webpack_public_path__ + "static/Plots0088-3a485ae26217a8b8d13a6a0a109b93a0.jpg";